module.exports = __webpack_public_path__ + "static/media/bionow.02eaa9e5.jpg";